import { Stack, Typography } from "@mui/material";
import SubtotalLabelFormat from "./SubtotalLabelFormat";
import SubtotalPosition from "./SubtotalPosition";

interface Props {
  disabled?: boolean;
}

const SubtotalLabelContainer = ({ disabled }: Props) => {
  return (
    <Stack
      sx={(t) => ({
        alignItems: "center",
        width: "100%",
        p: 1,
        gap: 1.5,
        borderRadius: 1,
        border: "1px solid " + t.palette.divider,
      })}
    >
      <Typography variant="subtitle2" sx={{ alignSelf: "start" }}>
        Subtotal Label
      </Typography>
      <SubtotalPosition disabled={disabled} />
      <SubtotalLabelFormat disabled={disabled} />
    </Stack>
  );
};

export default SubtotalLabelContainer;
